<template>
  <div class="modal-out">
    <div class="modal">
      <div class="modal-header">
        <div class="title">用药详情</div>
        <button type="button" class="btn-close" @click="closeSelf">X</button>
      </div>
      <div class="modal-body">

        <el-table :data="dataList" height="400" border>
          <el-table-column label="详情" prop="type">
            <template slot-scope="scope">
              <div>

                <div>早晨用药</div>
                <div style="padding-left: 30px;" v-for="(item,index) in scope.row.medicationSchedulingMorningDTO.medicationSchedulingMorningItemList" :key="index">
                  <span>药组：{{item.medicationGroupName}}<br></span>
                </div>
                <div>中午用药</div>
                <div style="padding-left: 30px;" v-for="(item,index) in scope.row.medicationSchedulingNoonDTO.medicationSchedulingNoonItemList" :key="index">
                  <span>药组：{{item.medicationGroupName}}<br></span>
                </div>
                <div>晚上用药</div>
                <div style="padding-left: 30px;" v-for="(item,index) in scope.row.medicationSchedulingNightDTO.medicationSchedulingNightItemList" :key="index">
                  <span>药组：{{item.medicationGroupName}}<br></span>
                </div>

              </div>
            </template>
          </el-table-column>
          <el-table-column label="时间" :formatter="timefilter" prop="time"></el-table-column>
          <el-table-column label="星期" prop="day"></el-table-column>
        </el-table>

      </div>
    </div>
  </div>
</template>

<script>

import {timeStr,timefilters} from "@/common/times";
import {getStaffCode} from "@/utils/auth";

export default {
  name: "Add",
  props:['dataList'],
  data() {
    return {

      loading: false,
      add_waresCode:'',
      pageSize:20,
      currentPage:1,
      showModalAdd:false,
      tableData:[],
      waresList:[],
      status:0,
      totalItems: 0,
      th:0,
      datetimerangeValue:[],
      statusValue:['老人状态','正常','禁用'],
      name:'',
      addForm:{
        timeStr:timeStr,
        sign:'',
        staffCode:getStaffCode(),
        medicinerCode:'',
      },
      medicinerCode:'',
      rules:{
        name:[
          { required: true, message: '物品名称', trigger: 'blur' },
        ],
        sort:[
          { required: true, message: '请输入库存', trigger: 'blur' },
          { type: 'number', message: '库存必须为数字值'}
        ],
      }
    }
  },

  methods: {
    init(){

    },
    closeSelf() {
      this.$emit("closeInfo");
    },
    timefilter(row, column, cellValue){
      return timefilters(cellValue).substring(0,10)
    },


  }
}
</script>

<style  lang="scss" scoped>

</style>
